export type TFSERegistrationStatusId = number;

export interface FSERegistrationStatus {
  id: TFSERegistrationStatusId;
  name: string;
}
